import type { ComponentProps } from 'react';

import { Box, HStack } from '@squire/ui';

import { styles } from './styles';

const MaxWidthWrapper = ({
  children,
  ...props
}: ComponentProps<typeof HStack>) => {
  return (
    <HStack flex fullWidth centerHorizontal {...props}>
      <Box style={styles.container}>{children}</Box>
    </HStack>
  );
};

MaxWidthWrapper.displayName = 'MaxWidthWrapper';
export { MaxWidthWrapper };
